/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useRef, useEffect } from 'react'
import Loader from '../Loader'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux';
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { getTheme } from '../../common/StyleSeter'
import moment from 'moment'
import { ADMIN_API } from '../../common/common';
import { postApiAdmin } from '../../service';
import { Logout } from '../../common/Funcation';
import ProfitlossCard from './ProfitlossCard';

const CATEGORY_TAB = [
  { name: "All", value: "all" },
  { name: "Exchange", value: "exchange" },
  { name: "Fancybet", value: "fancyBet" },
  { name: "Bookmaker", value: "bookMaker" },
  { name: "Sportsbook", value: "sportsBook" },
  { name: "Binary", value: "binary" },
  { name: "AWC", value: "casinoBet" },
]

function ProfitLoss(_props) {
  const HeaderData = useSelector((e) => e.Header);
  const userData = useSelector((e) => e.userData);
  const userId = HeaderData?._id
  const [isLoadingMain, setIsLoadingMain] = useState(false)
  const [activeCategory, setActiveCategory] = useState('All')
  const [during, setDuring] = useState(false)
  // const [duringFilter, setDuringFilter] = useState('today')
  const navigate = useNavigate()
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [showFromCalendar, setShowFromCalendar] = useState(false);
  const [showToCalendar, setShowToCalendar] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [pageData, setPageData] = useState({});
  const [expandedCardId, setExpandedCardId] = useState(null);
  // eslint-disable-next-line no-unused-vars
  // const [originalPageData, setOriginalPageData] = useState([]);
  const DD = useSelector((e) => e.domainDetails);
  const [loading, setLoading] = useState(false)

  // const tabsRef = useRef([]);
  // const [sliderStyle, setSliderStyle] = useState({ left: 0, width: 0 });

  const tabsRef = useRef([]);
  const tabsContainerRef = useRef(null);

  const [sliderStyle, setSliderStyle] = useState({
    left: 0,
    width: 0,
  });

  // useEffect(() => {
  //   const tabIndex = activeCategory === 'Exchange' ? 0 : activeCategory === 'Bookmaker' ? 1 : activeCategory === 'Fancybet' ? 2 : activeCategory === 'Sportsbook' ? 3 : activeCategory === 'Tie' ? 4 : activeCategory === 'Toss' ? 5 : activeCategory === 'Casino' ? 6 : 7;
  //   const currentTab = tabsRef.current[tabIndex];
  //   if (currentTab) {
  //     setSliderStyle({
  //       left: currentTab.offsetLeft,
  //       width: currentTab.offsetWidth,
  //     });
  //   }
  // }, [activeCategory]);

  useEffect(() => {
    setExpandedCardId(null);
    getPageData();
    return () => {
    };
  }, [activeCategory]);


  const getPageData = async (selectedFromDate = fromDate,
    selectedToDate = toDate) => {
    const playerId = userId ? userId : userData?._id;

    if (!playerId) {
      setPageData({
        rows: [],
        total: 0,
        totalPages: 1
      });

      setIsLoadingMain(false);
      return;
    }

    setIsLoadingMain(true);

    const data = {
      api: ADMIN_API.PLAYER_PROFIT_LOSS,
      value: {
        id: playerId,
        betType:
          CATEGORY_TAB.find(
            (item) => item.name === activeCategory
          )?.value || 'exchange',

        filter: "date",

        // Use complete days just like Comp1's date filtering
        from: moment(selectedFromDate).startOf('day').toISOString(),
        to: moment(selectedToDate).endOf('day').toISOString(),

        page: 1,
        limit: 100,
        sport: 'ALL',
      }
    };

    await postApiAdmin(data)
      .then(function (response) {
        const data = response?.data?.data;
        setPageData(data);
      })
      .catch(err => {
        setPageData({
          rows: [],
          total: 0,
          totalPages: 1
        });

        if (err.response?.data?.statusCode === 401) {
          Logout();
          navigate('/login');
        }
      })
      .finally(() => {
        setIsLoadingMain(false);
      });
  };

  useEffect(() => {
    const activeTab = tabsRef.current.find(
      (tab) =>
        tab?.textContent?.trim() === activeCategory
    );

    const tabsContainer = tabsContainerRef.current;

    if (!activeTab || !tabsContainer) return;

    const tabRect = activeTab.getBoundingClientRect();
    const containerRect = tabsContainer.getBoundingClientRect();

    setSliderStyle({
      left: tabRect.left - containerRect.left + tabsContainer.scrollLeft,
      width: tabRect.width,
    });

    const tabLeft = activeTab.offsetLeft;
    const tabRight = tabLeft + activeTab.offsetWidth;

    const visibleLeft = tabsContainer.scrollLeft;
    const visibleRight =
      visibleLeft + tabsContainer.clientWidth;

    if (tabLeft < visibleLeft) {
      tabsContainer.scrollTo({
        left: tabLeft - 10,
        behavior: 'smooth',
      });
    } else if (tabRight > visibleRight) {
      tabsContainer.scrollTo({
        left: tabRight - tabsContainer.clientWidth + 10,
        behavior: 'smooth',
      });
    }
  }, [activeCategory]);


  return (
    <>
      {/* <div>
        {JSON.stringify(pageData)}
      </div> */}
      <div className='full-wrap bottomfooter leagues'>
        {isLoadingMain &&
          <div className='loader_top'>
            <Loader />
          </div>
        }
        <>
          <style>{`
                    .paddingZero {
                    padding-left: 0px !important;
                    }
                    .sports-tab-panel {
                          position: relative;
                      }

                      .sports-tab-scroll {
                          position: relative;
                          width: 100%;
                          overflow-x: auto;
                          overflow-y: hidden;
                          -webkit-overflow-scrolling: touch;
                          scrollbar-width: none;
                      }

                      .sports-tab-scroll::-webkit-scrollbar {
                          display: none;
                      }

                      .sports-tab-list {
                          position: relative;
                          display: inline-flex;
                          align-items: center;
                          flex-wrap: nowrap;
                          list-style: none;
                          width: max-content;
                          min-width: 100%;
                          margin: 0;
                          padding: 0 0 6px 0;
                          box-sizing: border-box;
                      }

                      .sports-tab-panel-item {
                          position: relative;
                          flex: 0 0 auto;
                          cursor: pointer;
                          margin: 0 8px;
                          white-space: nowrap;
                      }

                      .sports-tab-panel-item h3 {
                          margin: 0;
                          padding: 0;
                          font-weight: 700;
                          font-size: 13.52px;
                      }

                      .sports-tab-panel-item.selected h3 {
                          font-weight: 700;
                      }

                      .sports-tab-panel-item.not-selected h3 {
                          font-weight: 700;
                      }

                      .tab-slider {
                          position: absolute;
                          bottom: 0px;
                          height: 4px;
                          background-color: black;
                          border-radius: 10px;

                          transition:
                              left 0.3s ease,
                              width 0.3s ease;

                          pointer-events: none;
                      }
                    .sports-tab-panel-item h3 {
                        margin: 0;
                        padding: 0;
                    }
                    .sports-tab-panel-item.selected h3 {
                        font-weight: 700;
                        font-size: 13.52px;
                    }
                    .sports-tab-panel-item.not-selected h3 {
                        font-weight: 700;
                        font-size: 13.52px;
                    }
                    .tab-slider {
                        transition: left 0.3s ease, width 0.3s ease !important;
                        margin: 0;
                        padding: 0;
                    }
                    .custom-calendar {
                        background: white;
                        border: 1px solid #d4e0e5;
                        border-radius: 8px;
                        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                    }
                    .custom-calendar .react-datepicker__day--highlighted {
                        background-color: #ffc107 !important;
                        color: white !important;
                        border-radius: 50%;
                    }
                    .custom-calendar .react-datepicker__day--selected {
                        background-color: #ffc107 !important;
                        color: white !important;
                        border-radius: 50%;
                    }
                    .custom-calendar .react-datepicker__header {
                        background-color: #f8f9fa;
                        border-bottom: 1px solid #d4e0e5;
                        padding: 0px;
                    }
                    .custom-calendar .react-datepicker__current-month {
                        color: #fff;
                        font-weight: 600;
                        height: 32px;
                        background: ${getTheme(DD?.colorSchema)?.backgroundColor};
                        padding-top: 3px !important;
                    }
                    .custom-calendar .react-datepicker__navigation-icon::before {
                        border-color: white;
                    }
                    .custom-calendar .react-datepicker__navigation-icon:hover::before {
                        border-color: white;
                    }
                    .custom-calendar .react-datepicker__navigation {
                        background-color: ${getTheme(DD?.colorSchema)?.backgroundColor} !important;
                        border-radius: 4px;
                        width: 32px;
                        height: 32px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        top: 0px;
                    }
                    .custom-calendar .react-datepicker__navigation:hover {
                        background-color: ${getTheme(DD?.colorSchema)?.backgroundColor} !important;
                        opacity: 0.8;
                    }
                    .custom-calendar .react-datepicker__day-name {
                        color: #666;
                        font-weight: 500;
                    }
                    .custom-calendar .react-datepicker__day {
                        color: #333;
                    }
                    .custom-calendar .react-datepicker__day:hover {
                        background-color: #e9ecef;
                    }
                    .calendar-dropdown {
                        animation: slideDown 0.3s ease;
                    }
                    @keyframes slideDown {
                        from {
                            opacity: 0;
                            max-height: 0;
                            overflow: hidden;
                        }
                        to {
                            opacity: 1;
                            max-height: 500px;
                            overflow: visible;
                        }
                    }
                `}</style>
          <div className="paddingZero balance-label position-relative" style={{ fontSize: "14.56px", fontWeight: 400 }}>
            {/* <button className="bg-transparent border-0 text-white position-absolute start-0 pt-0" onClick={() => navigate('/')}>
            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 256 512" className="fs-3" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
              <path d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"></path>
            </svg>
          </button> */}
            Profit & Loss
            <div className='cross-icon' onClick={() => navigate('/')} />
          </div>

          <div className="pt-0 inner-sidebar-content">
            {/* <div className='sports-tab-panel position-relative' style={{ paddingLeft: "0.5rem", paddingRight: 0, paddingBottom: "0.75rem", paddingTop: "0.75rem" }}>
                <div style={{ position: 'relative' }}>
                  <ul className="mb-0 p-0 d-flex">
                    <li ref={el => tabsRef.current[0] = el} className={`${activeCategory === 'Exchange' ? 'selected' : 'not-selected'} sports-tab-panel-item`} onClick={() => setActiveCategory('Exchange')}>
                      <h3>Exchange</h3>
                    </li>
                    <li ref={el => tabsRef.current[1] = el} className={`${activeCategory === 'Bookmaker' ? 'selected' : 'not-selected'} sports-tab-panel-item`} onClick={() => setActiveCategory('Bookmaker')}>
                      <h3>Bookmaker</h3>
                    </li>
                    <li ref={el => tabsRef.current[2] = el} className={`${activeCategory === 'Fancybet' ? 'selected' : 'not-selected'} sports-tab-panel-item`} onClick={() => setActiveCategory('Fancybet')}>
                      <h3>Fancybet</h3>
                    </li>
                    <li ref={el => tabsRef.current[3] = el} className={`${activeCategory === 'Sportsbook' ? 'selected' : 'not-selected'} sports-tab-panel-item`} onClick={() => setActiveCategory('Sportsbook')}>
                      <h3>Sportsbook</h3>
                    </li>
                    <li ref={el => tabsRef.current[4] = el} className={`${activeCategory === 'Tie' ? 'selected' : 'not-selected'} sports-tab-panel-item`} onClick={() => setActiveCategory('Tie')}>
                      <h3>Tie</h3>
                    </li>
                    <li ref={el => tabsRef.current[5] = el} className={`${activeCategory === 'Toss' ? 'selected' : 'not-selected'} sports-tab-panel-item`} onClick={() => setActiveCategory('Toss')}>
                      <h3>Toss</h3>
                    </li>
                    <li ref={el => tabsRef.current[6] = el} className={`${activeCategory === 'Casino' ? 'selected' : 'not-selected'} sports-tab-panel-item`} onClick={() => setActiveCategory('Casino')}>
                      <h3>Casino</h3>
                    </li>
                    <li ref={el => tabsRef.current[7] = el} className={`${activeCategory === 'Parlay' ? 'selected' : 'not-selected'} sports-tab-panel-item`} onClick={() => setActiveCategory('Parlay')}>
                      <h3>Parlay</h3>
                    </li>
                  </ul>
                  <div className="tab-slider" style={{
                    position: 'absolute',
                    bottom: '-4px',
                    height: '4px',
                    backgroundColor: 'black',
                    transition: 'left 0.3s ease, width 0.3s ease',
                    left: `${sliderStyle.left}px`,
                    width: `${sliderStyle.width}px`,
                    borderRadius: '10px'
                  }} />
                </div>
              </div> */}

            <div
              className="sports-tab-panel position-relative"
              style={{
                paddingLeft: "0.5rem",
                paddingRight: 0,
                paddingBottom: "0.3rem",
                paddingTop: "0.6rem",
              }}
            >
              <div
                ref={tabsContainerRef}
                className="sports-tab-scroll"
              >
                <ul className="sports-tab-list">
                  <li
                    ref={(el) => (tabsRef.current[0] = el)}
                    className={`sports-tab-panel-item ${activeCategory === 'All'
                      ? 'selected'
                      : 'not-selected'
                      }`}
                    onClick={() => setActiveCategory('All')}
                  >
                    <h3>All</h3>
                  </li>

                  <li
                    ref={(el) => (tabsRef.current[1] = el)}
                    className={`sports-tab-panel-item ${activeCategory === 'Exchange'
                      ? 'selected'
                      : 'not-selected'
                      }`}
                    onClick={() => setActiveCategory('Exchange')}
                  >
                    <h3>Exchange</h3>
                  </li>

                  <li
                    ref={(el) => (tabsRef.current[2] = el)}
                    className={`sports-tab-panel-item ${activeCategory === 'Fancybet'
                      ? 'selected'
                      : 'not-selected'
                      }`}
                    onClick={() => setActiveCategory('Fancybet')}
                  >
                    <h3>Fancybet</h3>
                  </li>

                  <li
                    ref={(el) => (tabsRef.current[3] = el)}
                    className={`sports-tab-panel-item ${activeCategory === 'Bookmaker'
                      ? 'selected'
                      : 'not-selected'
                      }`}
                    onClick={() => setActiveCategory('Bookmaker')}
                  >
                    <h3>Bookmaker</h3>
                  </li>

                  <li
                    ref={(el) => (tabsRef.current[4] = el)}
                    className={`sports-tab-panel-item ${activeCategory === 'Sportsbook'
                      ? 'selected'
                      : 'not-selected'
                      }`}
                    onClick={() => setActiveCategory('Sportsbook')}
                  >
                    <h3>Sportsbook</h3>
                  </li>

                  <li
                    ref={(el) => (tabsRef.current[5] = el)}
                    className={`sports-tab-panel-item ${activeCategory === 'Binary'
                      ? 'selected'
                      : 'not-selected'
                      }`}
                    onClick={() => setActiveCategory('Binary')}
                  >
                    <h3>Binary</h3>
                  </li>

                  <li
                    ref={(el) => (tabsRef.current[6] = el)}
                    className={`sports-tab-panel-item ${activeCategory === 'AWC'
                      ? 'selected'
                      : 'not-selected'
                      }`}
                    onClick={() => setActiveCategory('AWC')}
                  >
                    <h3>AWC</h3>
                  </li>

                  <div
                    className="tab-slider"
                    style={{
                      left: `${sliderStyle.left}px`,
                      width: `${sliderStyle.width}px`,
                    }}
                  />
                </ul>
              </div>
            </div>

            <div className="pl-filter">
              <div className="select-container bet-history-dropdown">
                <div className="pl-filter-first p-0" style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <div className="pl-filter-first-time" style={{ position: 'relative', display: 'flex', justifyContent: "start", alignItems: 'center', gap: '8px', width: "100%" }}>
                    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                      <path d="M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v136h656V256H712v48z"></path>
                      <path d="M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zm0-448H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136z"></path>
                    </svg>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div style={{ position: 'relative', width: "100px", textAlign: "start" }}>
                        <span className="text-white truncate" onClick={() => { setShowFromCalendar(!showFromCalendar); setShowToCalendar(false); }} style={{ cursor: 'pointer' }}>
                          {new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(fromDate).replace(/\//g, '-')}
                        </span>
                        {showFromCalendar && (
                          <div className="calendar-dropdown" style={{ position: 'absolute', top: '100%', left: "-40px", zIndex: 1000, marginTop: '4px' }}>
                            <DatePicker
                              selected={fromDate}
                              onChange={(date) => { setFromDate(date); setShowFromCalendar(false) }}
                              inline
                              highlightDates={[fromDate]}
                              calendarClassName="custom-calendar"
                              dateFormat="dd-MM-yyyy"
                            />
                          </div>
                        )}
                      </div>
                      <div style={{ position: 'relative', width: "100px", textAlign: "start" }}>
                        <span className="text-white truncate" onClick={() => { setShowToCalendar(!showToCalendar); setShowFromCalendar(false); }} style={{ cursor: 'pointer' }}>
                          {new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(toDate).replace(/\//g, '-')}
                        </span>
                        {showToCalendar && (
                          <div className="calendar-dropdown" style={{ position: 'absolute', top: '100%', left: "-40px", zIndex: 1000, marginTop: '4px' }}>
                            <DatePicker
                              selected={toDate}
                              onChange={(date) => { setToDate(date); setShowToCalendar(false) }}
                              inline
                              highlightDates={[toDate]}
                              calendarClassName="custom-calendar"
                              dateFormat="dd-MM-yyyy"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <button type="button" className="btn btn-primary" style={{ padding: "0 0.5rem 0 0.5rem", height: "31.5px" }} onClick={() => setDuring(!during)}>···</button>
                  <button type="button" className="btn btn-primary" onClick={() => {
                    setDuring(false);
                    getPageData();
                  }}>Submit</button>
                </div>
              </div>
            </div>

            {pageData && pageData.rows?.length > 0 && (
              <div
                style={{
                  width: "100%",
                  padding: "8px",
                  position: "relative",
                  background: "#1a1a1a",
                  boxSizing: "border-box",
                }}
              >
                {/* Select button */}
                <button
                  type="button"
                  style={{
                    width: "100%",
                    height: "30px",
                    padding: "0 16px",
                    border: "1px solid var(--bgColor)",
                    borderRadius: "4px",
                    background: "transparent",
                    color: "var(--bgColor)",
                    textAlign: "left",
                    fontSize: "15px",
                    cursor: "pointer",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        lineHeight: "1",
                      }}
                    >
                      {/* Selected option */}
                      <span
                        style={{
                          width: "100px",
                          fontWeight: "700",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        All
                      </span>

                      {/* Total P/L */}
                      <span
                        style={{
                          flex: 1,
                        }}
                      >
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <span
                            style={{
                              marginRight: "8px",
                            }}
                          >
                            Total P/L
                          </span>

                          <span
                            style={{
                              fontWeight: "700",
                              fontSize: "14px",
                              color: pageData.total > 0 ? "#00ff00" : "#ff0000",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {pageData.total}
                          </span>
                        </span>
                      </span>
                    </div>

                    {/* Arrow */}
                    <span
                      style={{
                        fontSize: "12px",
                        marginLeft: "8px",
                        marginTop: "2px",
                        display: "inline-block",
                        transition: "transform 300ms",
                      }}
                    >
                      ▼
                    </span>
                  </div>
                </button>
              </div>
            )}

            <div className='p-3'>
              {pageData && pageData?.rows?.length > 0 ? (
                pageData.rows.map((item, index) => {
                  const cardId = item._id || item.betId || `${item.settledDate}_${index}`;
                  return (
                    <ProfitlossCard
                      key={cardId}
                      item={item}
                      isExpanded={expandedCardId === cardId}
                      onToggle={() => setExpandedCardId(prev => (prev === cardId ? null : cardId))}
                    />
                  );
                })
              ) : (<div className='p-3'>
                <div className="no-event-outer">
                  <div className="no-event">
                    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" color="lightgrey" className="mb-2" height="55" width="55" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z"></path>
                    </svg>
                    No Event
                  </div>
                </div>
              </div>)}
            </div>


          </div>
        </>

      </div >



      {during && <div className="market-depth-modal">
        <div className="market-title">
          <h4 style={{ fontSize: "14.5749px" }}>During</h4>
          <button type="button" onClick={() => setDuring(false)} className="border-0 abc text-white position-absolute end-0 top-0 pt-1 fs-4 bg-transparent border-0 btn btn-primary">
            <svg stroke="currentColor" fill="none" strokeWidth="0" viewBox="0 0 15 15" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.80702 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z" fill="currentColor"></path>
            </svg>
          </button>
        </div>
        <div className="d-flex justify-content-center align-items-center w-100" style={{ padding: "0 0.5rem 0.5rem 0.5rem", background: "#000" }}>
          <div className="p-2 calendar-button" style={{ background: "#fff", borderRadius: "0.5rem", gap: "0.5rem" }}>
            <button type="button" className="btn btn-primary" style={{ fontSize: "12.5px", width: "100%" }} onClick={() => {
              const today = new Date();

              setFromDate(today);
              setToDate(today);
              setDuring(false);
              getPageData(today, today);
            }}>Today</button>
            <button type="button" className="btn btn-primary" style={{ fontSize: "12.5px", width: "100%" }} onClick={() => {
              const yesterday = moment()
                .subtract(1, 'day')
                .toDate();

              setFromDate(yesterday);
              setToDate(yesterday);
              setDuring(false);
              getPageData(yesterday, yesterday);
            }}>From Yesterday</button>
            <button type="button" className="btn btn-primary" style={{ fontSize: "12.5px", width: "100%" }} onClick={() => {
              const startDate = moment()
                .subtract(6, 'days')
                .startOf('day')
                .toDate();

              const endDate = moment()
                .endOf('day')
                .toDate();

              setFromDate(startDate);
              setToDate(endDate);
              setDuring(false);
              getPageData(startDate, endDate);
            }}>Last 7 Days</button>
          </div>
        </div>
      </div>}

    </>



  )
}

export default ProfitLoss